export default 'USER_SELECTED_PROMPT_SETTING';
